/* TC Academy — Gold Particles + Floating Barbershop Elements */
(function(){
  if(window.innerWidth<768||window.matchMedia('(prefers-reduced-motion:reduce)').matches)return;

  var canvas=document.createElement('canvas');
  canvas.id='tc-particles';
  canvas.style.cssText='position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:1;opacity:0.6;';
  document.body.appendChild(canvas);

  var ctx=canvas.getContext('2d');
  var W,H,particles=[],shapes=[],mouse={x:-999,y:-999};
  var gold='rgba(201,168,76,';
  var DPR=Math.min(window.devicePixelRatio||1,2);

  function resize(){
    W=window.innerWidth;H=window.innerHeight;
    canvas.width=W*DPR;canvas.height=H*DPR;
    ctx.scale(DPR,DPR);
  }
  resize();
  window.addEventListener('resize',resize);

  // Track mouse for subtle interaction
  document.addEventListener('mousemove',function(e){mouse.x=e.clientX;mouse.y=e.clientY;});

  // Gold dust particles
  var PARTICLE_COUNT=35;
  for(var i=0;i<PARTICLE_COUNT;i++){
    particles.push({
      x:Math.random()*W,
      y:Math.random()*H,
      size:Math.random()*2+0.5,
      speedX:(Math.random()-0.5)*0.15,
      speedY:Math.random()*-0.3-0.05,
      opacity:Math.random()*0.4+0.1,
      pulse:Math.random()*Math.PI*2,
      pulseSpeed:Math.random()*0.02+0.005
    });
  }

  // Floating barbershop SVG shapes
  var svgPaths=[
    // Scissors
    'M6,6a3,3,0,1,0-3,3,3,3,0,0,0,3-3ZM6,18a3,3,0,1,0-3-3,3,3,0,0,0,3,3ZM20,4,8.12,15.88M14.47,14.48,20,20M8.12,8.12,12,12',
    // Comb
    'M2,5H22M2,9H22M2,13H22M2,17H22M6,3V19M10,3V19M14,3V19M18,3V19',
    // Razor blade
    'M3,7H21a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H3a2,2,0,0,1-2-2V9A2,2,0,0,1,3,7ZM8,11h8',
    // Star
    'M12,2l3.09,6.26L22,9.27l-5,4.87,1.18,6.88L12,17.77,5.82,21.02,7,14.14,2,9.27l6.91-1.01Z',
    // Droplet
    'M12,2.69l5.66,5.66a8,8,0,1,1-11.31,0Z'
  ];

  var SHAPE_COUNT=6;
  for(var i=0;i<SHAPE_COUNT;i++){
    shapes.push({
      x:Math.random()*W,
      y:Math.random()*H,
      size:Math.random()*14+10,
      rotation:Math.random()*360,
      rotSpeed:(Math.random()-0.5)*0.15,
      speedX:(Math.random()-0.5)*0.08,
      speedY:(Math.random()-0.5)*0.08,
      opacity:Math.random()*0.06+0.02,
      path:svgPaths[i%svgPaths.length],
      floatPhase:Math.random()*Math.PI*2,
      floatAmp:Math.random()*15+5
    });
  }

  function drawParticle(p){
    var o=p.opacity*(0.6+0.4*Math.sin(p.pulse));
    ctx.beginPath();
    ctx.arc(p.x,p.y,p.size,0,Math.PI*2);
    ctx.fillStyle=gold+o+')';
    ctx.fill();
    // Glow
    if(p.size>1.2){
      ctx.beginPath();
      ctx.arc(p.x,p.y,p.size*3,0,Math.PI*2);
      ctx.fillStyle=gold+(o*0.15)+')';
      ctx.fill();
    }
  }

  function drawShape(s,time){
    var floatY=Math.sin(time*0.0008+s.floatPhase)*s.floatAmp;
    var floatX=Math.cos(time*0.0005+s.floatPhase)*s.floatAmp*0.5;

    ctx.save();
    ctx.translate(s.x+floatX,s.y+floatY);
    ctx.rotate((s.rotation+time*s.rotSpeed*0.05)*Math.PI/180);
    ctx.globalAlpha=s.opacity;
    ctx.strokeStyle=gold+'0.5)';
    ctx.lineWidth=0.8;
    ctx.scale(s.size/24,s.size/24);
    ctx.translate(-12,-12);

    // Draw SVG path manually
    var path=new Path2D();
    var cmds=s.path.split(/(?=[MLHVCSQTAZ])/i);
    cmds.forEach(function(cmd){
      cmd=cmd.trim();
      if(!cmd)return;
      var type=cmd[0];
      var nums=cmd.slice(1).split(/[,\s]+/).map(Number);
      switch(type){
        case'M':path.moveTo(nums[0],nums[1]);break;
        case'L':path.lineTo(nums[0],nums[1]);break;
        case'H':path.lineTo(nums[0],0);break;
        case'V':path.lineTo(0,nums[0]);break;
        case'Z':case'z':path.closePath();break;
      }
    });
    ctx.stroke(path);

    // Fallback: draw as simple geometric shape based on index
    ctx.beginPath();
    if(s.path.indexOf('Scissors')>-1||svgPaths.indexOf(s.path)===0){
      // Scissors shape
      ctx.arc(6,6,3,0,Math.PI*2);
      ctx.moveTo(9,18);ctx.arc(6,18,3,0,Math.PI*2);
      ctx.moveTo(20,4);ctx.lineTo(8,16);
      ctx.moveTo(14,14);ctx.lineTo(20,20);
    }else if(svgPaths.indexOf(s.path)===3){
      // Star
      for(var i=0;i<5;i++){
        var a=(i*72-90)*Math.PI/180;
        var r1=12,r2=5;
        if(i===0)ctx.moveTo(12+r1*Math.cos(a),12+r1*Math.sin(a));
        else ctx.lineTo(12+r1*Math.cos(a),12+r1*Math.sin(a));
        var a2=((i*72+36)-90)*Math.PI/180;
        ctx.lineTo(12+r2*Math.cos(a2),12+r2*Math.sin(a2));
      }
      ctx.closePath();
    }else{
      // Generic: crosshair / plus
      ctx.moveTo(12,4);ctx.lineTo(12,20);
      ctx.moveTo(4,12);ctx.lineTo(20,12);
    }
    ctx.stroke();

    ctx.restore();
  }

  function animate(time){
    ctx.clearRect(0,0,W,H);

    // Update and draw particles
    for(var i=0;i<particles.length;i++){
      var p=particles[i];
      p.x+=p.speedX;
      p.y+=p.speedY;
      p.pulse+=p.pulseSpeed;

      // Mouse repel (subtle)
      var dx=p.x-mouse.x,dy=p.y-mouse.y;
      var dist=Math.sqrt(dx*dx+dy*dy);
      if(dist<120&&dist>0){
        p.x+=dx/dist*0.3;
        p.y+=dy/dist*0.3;
      }

      // Wrap around
      if(p.y<-10){p.y=H+10;p.x=Math.random()*W;}
      if(p.x<-10)p.x=W+10;
      if(p.x>W+10)p.x=-10;

      drawParticle(p);
    }

    // Draw floating shapes
    for(var i=0;i<shapes.length;i++){
      var s=shapes[i];
      s.x+=s.speedX;
      s.y+=s.speedY;
      s.rotation+=s.rotSpeed;

      // Wrap
      if(s.x<-50)s.x=W+50;
      if(s.x>W+50)s.x=-50;
      if(s.y<-50)s.y=H+50;
      if(s.y>W+50)s.y=-50;

      drawShape(s,time);
    }

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
})();
